define('views/shared/form/input/password_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/input/password_component.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'form-input',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {
            'keyup input': 'validatePassword',
            'blur input': 'checkPassword',
            'click .js-form-input-password-toggle-show': 'togglePasswordVisibility',
            'click .js-form-input-password-toggle-hide': 'togglePasswordVisibility'
        },

        initialize: function(options){
            options = options || {};

            this.field = options.field;

            this.is_valid = false;
            this.is_hidden = true;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());
            
            // if autocomplete is false and we're in chrome
            if (!this.field.autocomplete && window.chrome) {  
                this.field.autocomplete = 'autocomplete-off-' + (new Date()).getTime();
            }             

            this.listRules();

            return this;
        },

        loadData: function(){

            if(this.field.visibility){
                this.$el.addClass('password-toggle');
            }

            this.render();
            
        },

        getValue: function(){
            return encrypt(this.$el.find('input').val());
        },

        showError: function(){
            this.checkPassword();
        },

        removeError: function(){},

        validatePassword: function(){
            this.updatePasswordRules();
        },

        checkPassword: function(){
            this.updatePasswordRules(true);

            if(this.is_valid){
                // this.$el.find('.js-password-rules').hide();
            }
        },

        updatePasswordRules: function(show_errors){
            var pw_input = this.$el.find('input'),
                value = pw_input.val(),
                length_pattern = /^.{8,}$/,
                capital_pattern = /.*[A-Z]/,
                lowercase_pattern = /.*[a-z]/,
                number_pattern = /.*[0-9]/,
                pw_failed = false;

            if(length_pattern.test(value)){
                this.$('.js-password-length').removeClass('text-red');
                this.$('.js-password-length').addClass('text-green');
            } else {
                this.$('.js-password-length').removeClass('text-green');

                if(show_errors){
                    this.$('.js-password-length').addClass('text-red');
                }
                
                pw_failed = true;
            }

            if(capital_pattern.test(value)){
                this.$('.js-password-uppercase').removeClass('text-red');
                this.$('.js-password-uppercase').addClass('text-green');
            } else {
                this.$('.js-password-uppercase').removeClass('text-green');

                if(show_errors){
                    this.$('.js-password-uppercase').addClass('text-red');
                }
                
                pw_failed = true;
            }

            if(lowercase_pattern.test(value)){
                this.$('.js-password-lowercase').removeClass('text-red');
                this.$('.js-password-lowercase').addClass('text-green');
            } else {
                this.$('.js-password-lowercase').removeClass('text-green');

                if(show_errors){
                    this.$('.js-password-lowercase').addClass('text-red');
                }
                
                pw_failed = true;
            }

            if(number_pattern.test(value)){
                this.$('.js-password-number').removeClass('text-red');
                this.$('.js-password-number').addClass('text-green');
            } else {
                this.$('.js-password-number').removeClass('text-green');

                if(show_errors){
                    this.$('.js-password-number').addClass('text-red');
                }
                
                pw_failed = true;
            }

            if(pw_failed){
                this.is_valid = false;
                this.$el.find('.js-password-rules').show();

                if(show_errors){
                    this.$el.addClass('error');
                }

            } else {
                this.is_valid = true;

                this.$el.removeClass('error');
                // this.$el.find('.js-password-rules').hide();
            }

        },

        togglePasswordVisibility: function(){
            var show_btn = this.$('.js-form-input-password-toggle-show'),
                hide_btn = this.$('.js-form-input-password-toggle-hide'),
                input = this.$el.find('input');

            if(this.is_hidden){

                this.is_hidden = false;
                show_btn.hide();
                hide_btn.show();
                input.attr('type', 'text');

            } else {
                
                this.is_hidden = true;
                hide_btn.hide();
                show_btn.show();
                input.attr('type', 'password');
                
            }
        },

        listRules: function(){

            var that = this,
                list = pf.getContent('form.content.password.rules.list');

            if(_.isArray(list)){

                list.forEach(function(rule){

                    var item = document.createElement('li');

                    item.className = rule.class;
                    item.innerHTML = rule.text;

                    that.$('.js-password-rules-list').append(item);
                });

            }

        },

        close: function(){}
    });
});

